import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}

const ExpositorsList: React.FC = () => {
  const endpoint = '/expositorlist';
  const title = 'Cortesias';

  const schema: Record<string, any> = {
    id: { ref: 'id', column: 'id', label: 'ID', show: false },
    hash: { ref: 'hash', column: 'hash', label: 'Hash' },
    category: { ref: 'category', column: 'category', label: 'Categoria' },
    title: { ref: 'title', column: 'title', label: 'Expositor' },

    quantity: { ref: 'quantity', column: 'quantity', label: 'Quantidade de ingressos' },
    owner: { ref: 'owner', column: 'owner', label: 'Responsável' },
    phone: { ref: 'phone', column: 'phone', label: 'Telefone' },
    product: {
      ref: 'product',
      column: 'product_response',
      includeColumn: 'title',
      label: 'Produto / Ingresso',
    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    hash: { model: 'input', type: 'text', name: 'hash', label: 'Hash (Código Promocional)' },
    category: {
      model: 'selectSimple',
      category: 'text',
      name: 'category',
      label: 'Categoria',

      options: [
        { id: 'Patrocinador', value: 'Patrocinador', label: 'Patrocinador' },
        { id: 'Expositor', value: 'Expositor', label: 'Expositor' },
        { id: 'Imprensa', value: 'Imprensa', label: 'Imprensa' },
        { id: 'Organização', value: 'Organização', label: 'Organização' },
        { id: 'Staff', value: 'Staff', label: 'Staff' },
        { id: 'Fornecedores', value: 'Fornecedores', label: 'Fornecedores' },
        { id: 'Participantes' , value: 'Participantes' , label: 'Participantes' },
        { id: 'Caravana' , value: 'Caravana' , label: 'Caravana' },
        { id: 'Palestrantes' , value: 'Palestrantes' , label: 'Palestrantes' },
      ],
    },
    title: { model: 'input', type: 'text', name: 'title', label: 'Nome do Patrocinador' },
    quantity: { model: 'input', type: 'text', name: 'quantity', label: 'Quantidade de ingressos' },
    owner: { model: 'input', type: 'text', name: 'owner', label: 'Responsável' },
    phone: { model: 'input', type: 'text', name: 'phone', label: 'Telefone' },

    product: {
      alias: 'product',
      model: 'selectApi',
      name: 'product',
      label: 'Produto / Ingresso',

      endpoint,
    },
  };

  const formSchemaUpdate = formSchema;

  const formValidation: Record<string, ValidationSchema> = {
  
  };

  const config: ISearchComponent = {
    idKey: endpoint,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
      lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };
  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default ExpositorsList;
